import { useState } from "react";
import { Box, Grid, TextField, Typography } from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";

// import { Loading } from "components/shared";
import { useSet, useInstallation } from "hooks";
import { useEffect } from "react";
import { useSession } from "context/SessionContext";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainGrid: {
      marginBottom: "10px",
      display: "flex",
    },
    labelRoot: {
      fontSize: 30,
      color: "black",

      // "&$labelFocused": {
      //   fontWeight: "bold",
      // },
    },
    marginModulocker: {
      paddingLeft: '10px',
    },
    marginGrid: {
      paddingLeft: '20px',
      
    },
    labelFocused: {},
    root: {
      minWidth: "160px",
      "& .MuiInputBase-input": {
        boxShadow: "none",
      },
      "& .MuiInputLabel-outlined": {
        transform: "translate(14px, 14px) scale(1)",
      },
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(1)",
      },
      "& .MuiSelect-icon": {
        top: "calc(50% - 8px)",
      },
      "& .MuiInputBase-root": {
        // height: '40px',
        fontSize: "1.2rem",
        fontWeight: "500",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
      "& .MuiInputLabel-root": {
        fontSize: "1.2rem",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
      "& .MuiOutlinedInput-input": {
        padding: "16px 14px",
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        fontSize: "1.2rem",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
    },
    "@media (max-width: 959px)": {
      marginModulocker: {
        paddingTop: '10px',
        paddingLeft: '0',
      },
    },
    "@media (max-width: 500px)": {
      mainGrid: {
        flexWrap: "wrap",
      },
    },
  })
);

type SelectItem = {
  label: string;
  value: string;
};

export default function SearchHeader() {
  const classes = useStyles();
  const { setIDMCM, setIDSITE, data, setData } = useSession();

  // const { getNewAdress } = useAddreesse();
  // const { update, setUpdate } = useContext(ListInstallsContext);
  const { autocompleteOptions } = useInstallation();

  const [selectedOption, setSelectedOption] = useState({
    label: "",
    value: "",
  });
  const [selectedSet, setSelectedSet] = useState({
    label: "",
    value: "",
  } as SelectItem);
  const [openAutocomplete, setOpenAutocomplete] = useState(true);
  // eslint-disable-next-line
  const [defaultValue, setDefaultValue] = useState(0);

  const {
    getAllSetsShort,
    getSetInformations,
    autoCsets,
    getOne,
    MCM,
  } = useSet();

  // vai ter que virar context para desprender o header
  // const theme = useTheme();
  // const isSM = useMediaQuery(theme.breakpoints.down("sm"));

  // FILL INSTALLATIONS OPTIONS
  // ------------------------------------------------------
  // useEffect(() => {
  //   (async () => {
  //     const newInstallations = installationsSelectOptions?.map(
  //       (installation) => {
  //         return {
  //           description: installation.description,
  //           label: installation.label,
  //           value: installation.label,
  //         };
  //       }
  //     );
  //     if (newInstallations.length > 0) {
  //       setData((state: any) => {
  //         const selectedInstallation =
  //           IDSITE.length > 0 ? IDSITE : newInstallations[0].value;
  //         setIDSITE(selectedInstallation);
  //         return {
  //           ...state,
  //           installations: newInstallations,
  //           installation: selectedInstallation,
  //         };
  //       });
  //     }
  //   })();

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [installationsSelectOptions]);

  // WHEN INSTALLATIONS CHANGING
  // -----------------------------------------------------
  useEffect(() => {
    const getSet = async () => {
      await getAllSetsShort({
        IDSITE: selectedOption.value,
        withLoading: true,
      });
    };
    getSet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);

  const handleChange = (id: any) => {
    if (!id) return;
    setIDMCM(id.value);
    getOne({ IDMCM: id.value });
    getSetInformations(id.value);
    localStorage.setItem("@adminModulockerCondsets", JSON.stringify(id));
  };

  const autoCompleteChange = (value: any) => {
    if (!value) return;

    setData({ ...data, installation: value?.value });
    setIDSITE(value?.value);
    localStorage.setItem(
      "@adminModulockerCondinstallation",
      JSON.stringify(data)
    );
    localStorage.setItem(
      "@adminModulockerCondselectedOption",
      JSON.stringify(value)
    );
  };

  useEffect(() => {
    // monta os autocomplete se tiver localstorage
    const selectedItem = JSON.parse(
      localStorage.getItem("@adminModulockerCondselectedOption") as any
    );
    const dataStorage = JSON.parse(
      localStorage.getItem("@adminModulockerCondinstallation") as any
    );
    const mcm = localStorage.getItem("adminIDMCM") as any;
    const site = localStorage.getItem("adminIDSITE") as any;
    const sets = JSON.parse(
      localStorage.getItem("@adminModulockerCondsets") as any
    );

    if (mcm) {
      setIDSITE(site);
      setIDMCM(mcm);
      getOne({ IDMCM: mcm });
      getSetInformations(mcm);
    }

    if (selectedItem) {
      getAllSetsShort(dataStorage.set);
      setSelectedOption(selectedItem);
      setSelectedSet(sets);
      setData(dataStorage);
      setOpenAutocomplete(false);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (autoCsets.length === 1) {
      setSelectedSet({
        label: autoCsets[0].label,
        value: autoCsets[0].value,
      });

      handleChange({ value: autoCsets[0].value, label: autoCsets[0].label });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoCsets]);

  return (
    <>
      <Grid container className={classes.mainGrid}>
        <Grid container item xs={6} sm={8}>
          <Grid sm={12} md={6}>
            <Autocomplete
              disablePortal
              open={openAutocomplete}
              onOpen={() => setOpenAutocomplete(true)}
              onClose={() => setOpenAutocomplete(false)}
              openOnFocus
              noOptionsText="Sem opções"
              id="combo-box-demo"
              options={autocompleteOptions ?? []}
              fullWidth
              value={selectedOption?.label}
              onChange={(_e, value) => {
                if (value) {
                  setSelectedOption(value);
                  handleChange({ label: "", value: "" });
                  setSelectedSet({ label: "", value: "" });
                  autoCompleteChange(value);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span>
                      INSTALAÇÃO <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  InputLabelProps={{
                    style: { fontSize: 14 },
                    classes: {
                      root: classes.labelRoot,
                      focused: classes.labelFocused,
                    },
                  }}
                />
              )}
              className={classes.root}
            />
          </Grid>

          <Grid sm={12} md={6} className={classes.marginModulocker}>
            <Autocomplete
              disablePortal
              noOptionsText="Sem opções"
              id="combo-box-demo"
              options={autoCsets ?? []}
              fullWidth
              value={selectedSet?.label}
              onChange={(_e, value) => {
                if (value) {
                  setSelectedSet(value as any);
                  handleChange(value);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span>
                      MODULOCKER <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  InputLabelProps={{
                    style: { fontSize: 14 },
                    classes: {
                      root: classes.labelRoot,
                      focused: classes.labelFocused,
                    },
                  }}
                />
              )}
              className={classes.root}
            />
          </Grid>
        </Grid>
        {MCM?.LOGRADOURO && (
        <Grid xs={6} sm={4} justifyContent="flex-end" className={classes.marginGrid}>
          <Box style={{display: 'flex', flexDirection: 'column'}}>
            <Typography style={{ fontSize: 11, color: "black" }}>
              ENDEREÇO
            </Typography>
            <Typography variant="h6">
              {MCM?.LOGRADOURO} - n° {MCM?.NUMERO}
            </Typography>
            <Typography variant="h6">
              {MCM?.BAIRRO} - {MCM?.DSCIDADE}
            </Typography>
          </Box>
        </Grid>
        )}
      </Grid>
      {(selectedOption.value === "" || selectedSet.value === "") && (
        <span style={{ color: "red" }}>* Preenchimento obrigatório</span>
      )}
    </>
  );
}
